"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceRegistryApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class ServiceRegistryApi extends runtime.BaseAPI {
    /**
     * Retrieve the attributes of given service registries.  **[Permissions](#permissions) required:** Only Connect apps can make this request and the servicesIds belong to the tenant you are requesting
     * Retrieve the attributes of service registries
     */
    serviceRegistryResourceServicesGetRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['serviceIds'] == null) {
                throw new runtime.RequiredError('serviceIds', 'Required parameter "serviceIds" was null or undefined when calling serviceRegistryResourceServicesGet().');
            }
            const queryParameters = {};
            if (requestParameters['serviceIds'] != null) {
                queryParameters['serviceIds'] = requestParameters['serviceIds'];
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/rest/atlassian-connect/1/service-registry`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.ServiceRegistryFromJSON));
        });
    }
    /**
     * Retrieve the attributes of given service registries.  **[Permissions](#permissions) required:** Only Connect apps can make this request and the servicesIds belong to the tenant you are requesting
     * Retrieve the attributes of service registries
     */
    serviceRegistryResourceServicesGet(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.serviceRegistryResourceServicesGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.ServiceRegistryApi = ServiceRegistryApi;
//# sourceMappingURL=ServiceRegistryApi.js.map